class AsyncDirective {
  constructor(loader, resolver) {
    this.loader = loader;
    this.resolver = resolver || (module => module);
    return this.wrapper();
  }

  resolve() {
    return this.loader().then(this.resolver);
  }

  wrapper() {
    return {
      bind: this.binder.bind(this),
      unbind: this.unbinder.bind(this)
    };
  }

  binder() {
    const args = arguments;
    this.resolve().then(directive => directive.bind.apply(null, args));
  }

  unbinder() {
    const args = arguments;
    this.resolve().then(directive => directive.unbind.apply(null, args));
  }
}

export default AsyncDirective;
